import { useDriversContext } from "./context";
import { InviteDriversModal } from "./modals/InviteDriversModal";

export const DriversModals = () => {
  const { step, setStep } = useDriversContext();

  return (
    <>
      <InviteDriversModal open={step === "invite"} onClose={() => setStep(undefined)} />
    </>
  );
};
